// src/ui/TypingBubble.jsx — the in-chat indicator.
//
// A bubble on the incoming side: three bouncing dots normally, or the matching media
// glyph when the other side is recording / sending something. In a GROUP each typer
// also gets their avatar, because "someone is typing" is useless when there are eight
// people — the phone does the same and 1-on-1 deliberately shows no avatar and no name.
import React from 'react';
import { Mic, Image as ImageIcon, Video, Doc } from './icons';
import Avatar from './Avatar';

const ACTIVITY_ICON = {
  recording: Mic,
  photo: ImageIcon,
  video: Video,
  album: ImageIcon,
  document: Doc,
};

function Dots() {
  return (
    <span className="ty-dots" aria-label="typing">
      <i /><i /><i />
    </span>
  );
}

export default function TypingBubble({ typers, chat, myUid, profiles }) {
  if (!typers?.length) return null;
  const shown = typers.slice(0, 3);
  const extra = typers.length - shown.length;
  const isGroup = !!chat?.isGroup;

  return (
    <div className="ty-wrap">
      {shown.map((t) => {
        const Icon = t.activity && t.activity !== 'typing' ? (ACTIVITY_ICON[t.activity] || null) : null;
        const recording = t.activity === 'recording';
        return (
          <div className="ty-row" key={t.uid}>
            {isGroup && (
              <Avatar
                profile={profiles?.[t.uid] || { fullName: t.name }}
                chat={{ participants: [t.uid] }}
                peerUid={t.uid}
                myUid={myUid}
                size="sm"
                showGroupBadge={false}
              />
            )}
            <div className="ty-bubble">
              {Icon
                ? <span className={`ty-act ${recording ? 'rec' : ''}`}><Icon width={17} height={17} /></span>
                : <Dots />}
            </div>
          </div>
        );
      })}
      {extra > 0 && <div className="ty-more">+{extra} more typing…</div>}
    </div>
  );
}
